module.exports = __webpack_public_path__ + "img/2362359.png";